import Navbar from "../components/common/Navbar";
import LoginForm from "../components/login/LoginForm";

const Login = () => {
  return (
    <div
      style={{
        position: "fixed",
        top: 0, left: 0, right: 0, bottom: 0,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        backgroundColor: "#0B0E13",
      }}
    >
      <Navbar />
      {/* 56px spacer for fixed navbar */}
      <div style={{ height: "56px", flexShrink: 0 }} />
      {/* LoginForm fills everything below */}
      <div style={{ flex: 1, overflow: "hidden", minHeight: 0 }}>
        <LoginForm />
      </div>
      {/* Copyright */}
      <div style={{ textAlign: "center", padding: "10px 0", color: "#475569", fontSize: "12px", flexShrink: 0 }}>
        © {new Date().getFullYear()} Cardiowell · Wellztech. All rights reserved.
      </div>
    </div>
  );
};

export default Login;

